import { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';

import { MplButton } from '../../atoms/MplButton';

type ISocialButtonProps = {
	name: 'google' | 'apple' | 'facebook' | 'microsoft';
	text: string;
	onClick: VoidFunction;
	icon: ReactNode;
};

const MplButtonStyled = styled(MplButton)(({ theme }) => ({
	outlineColor: `${theme.palette.neutral[40]}`,
	color: theme.palette.neutral[900],
	background: theme.palette.neutral[0],
}));

export const SocialButton: FC<ISocialButtonProps> = (props) => {
	const { icon, name, text, onClick } = props;

	return (
		<MplButtonStyled
			data-testid={`login-with-${name}-button`}
			variant="outlined"
			color="button_black"
			onClick={onClick}
			startIcon={icon}
		>
			{text}
		</MplButtonStyled>
	);
};
